import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '../../ui/Popover';

export default (Step) => {
  return useMemo(() => {
    const Popup = React.memo(({ children, onClose, onOpenChange, ...popoverProps }) => {
      const [isOpened, setIsOpened] = useState(false);

      // const wrapper = useRef(null);
      // const resizeObserver = useRef(null);

      const handleOpen = useCallback(() => {
        setIsOpened(true);
        if (onOpenChange) {
          onOpenChange(true);
        }
      }, [onOpenChange]);

      const handleClose = useCallback(() => {
        setIsOpened(false);
        if (onOpenChange) {
          onOpenChange(false);
        }

        if (onClose) {
          onClose();
        }
      }, [onClose, onOpenChange]);

      const handleOpenChange = useCallback(
        (open) => {
          if (open) {
            handleOpen();
          } else {
            handleClose();
          }
        },
        [handleOpen, handleClose],
      );

      const handleMouseDown = useCallback((event) => {
        event.stopPropagation();
      }, []);

      const handleClick = useCallback((event) => {
        event.stopPropagation();
      }, []);

      const handleTriggerClick = useCallback(
        (event) => {
          event.stopPropagation();

          const { onClick } = children;

          if (onClick) {
            onClick(event);
          }
        },
        [children],
      );

      // const handleContentRef = useCallback((element) => {
      //   if (resizeObserver.current) {
      //     resizeObserver.current.disconnect();
      //   }

      //   if (!element) {
      //     resizeObserver.current = null;
      //     return;
      //   }

      //   resizeObserver.current = new ResizeObserver(() => {
      //     if (resizeObserver.current.isInitial) {
      //       resizeObserver.current.isInitial = false;
      //       return;
      //     }

      //     wrapper.current.positionUpdate();
      //   });

      //   resizeObserver.current.isInitial = true;
      //   resizeObserver.current.observe(element);
      // }, []);

      const trigger = React.cloneElement(children, {
        onClick: handleTriggerClick,
      });

      return (
        <Popover
          {...popoverProps} // eslint-disable-line react/jsx-props-no-spreading
          trigger={trigger}
          content={<Step {...popoverProps} onClose={handleClose} />} // eslint-disable-line react/jsx-props-no-spreading
          hideCloseButton={popoverProps.hideCloseButton}
          open={isOpened}
          onOpenChange={handleOpenChange}
          onMouseDown={handleMouseDown}
          onClick={handleClick}
        />
      );
    });

    Popup.propTypes = {
      children: PropTypes.node.isRequired,
      onClose: PropTypes.func,
      onOpenChange: PropTypes.func,
      hideCloseButton: PropTypes.bool,
    };

    Popup.defaultProps = {
      onClose: undefined,
      onOpenChange: undefined,
      hideCloseButton: false,
    };

    return Popup;
  }, []);
};
